import ActionDialog from './action.vue'
import MessageDialog from './message.vue'
import LiveviewDialog from './liveview.vue'
import ConfirmDialog from './confirm.vue'
import BlockDialog from './block.vue'
import HiddenDialog from './hidden.vue'
import HelpOTPDialog from './helpOTP.vue'
import ApprovalRequestDialog from './approval-request.vue'
import SecurityDialog from './security.vue'
import ListModalDialog from './middleManagerListModal.vue';
import WarningDialog from './warning.vue'
import NewDeviceRegistrationDialog from './newDeviceRegistration.vue'
export {
  ActionDialog,
  MessageDialog,
  LiveviewDialog,
  ConfirmDialog,
  BlockDialog,
  HiddenDialog,
  HelpOTPDialog,
  ApprovalRequestDialog,
  SecurityDialog,
  ListModalDialog,
  WarningDialog,
  NewDeviceRegistrationDialog,
}
